import { gql } from '@apollo/client';

export const GET_AUDIT_DECISIONS = gql`
  query GetAuditDecisions($auditSessionId: String!) {
    auditDecisions(input: { auditSessionId: $auditSessionId }) {
      decisions {
        id
        type
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
        auditItemId
        auditSessionId
        auditorId
        auditorName
        timestamp
        updatedAt
        isSelected
        selectedBy
        selectedAt
        isCurrentUser
        languageCorrect
        transcriptionCorrect
        correctedTranscription
        ocrCorrect
        correctedOcr
        originalLabels {
          name
          severity
        }
        correctedLabels {
          name
          severity
        }
        comments
        labelsCorrect
        policiesCorrect
        triggeredPolicyAssessments {
          policyId
          policyName
          isCorrect
          comments
        }
        nonTriggeredPolicyAssessments {
          policyId
          policyName
          isCorrect
          comments
        }
      }
    }
  }
`;
